import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../../../store/index';
import { remove } from '../../../../../store/popups/remove';
import { IRemoveProps, Remove } from './index';

type TStoreProps = Pick<IRemoveProps, 'offerId' | 'status'>;
type TDispatchProps = Pick<IRemoveProps, 'onSubmit'>;

function mapStateToProps(state: IState): TStoreProps {
  return {
    offerId: state.pageData.offerId,
    status: state.remove.status,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    onSubmit: () => dispatch(remove()),
  };
}

export const RemoveContainer = connect<TStoreProps, TDispatchProps, {}>(mapStateToProps, mapDispatchToProps)(Remove);
